import React from 'react';
import {Button} from "react-bootstrap";
import {toAbsoluteUrl} from "../../../../../_metronic/_helpers";
import {useIntl} from "react-intl";
import {useDispatch} from "react-redux";
import {addCustomerToProject} from "../../_redux/projectsActions";

export function ButtonAddCustomer({projectId, customerId, name, email}) {
  const intl = useIntl();
  const dispatch = useDispatch();
  const tooltip = intl.formatMessage({
    id: "projects-popup-button-add-customer-tooltip",
    defaultMessage: "Handle project",
  });

  const buttonClassName = `btn btn-icon btn-light btn-sm mx-3 custom-action-button`;

  const handleAddCustomerToProject = () => {
    dispatch(addCustomerToProject(projectId, customerId.toString(), name, email));
  };

  return (
    <Button
      className={buttonClassName}
      onClick={() => handleAddCustomerToProject()}
      title={tooltip}
    >
      <img
        src={toAbsoluteUrl("/media/svg/Add-user_brandColor.svg")}
        alt="icon"
      />
    </Button>
  )
}
